import { FlexibleConnectedPositionStrategyOrigin, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentType, ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Injectable, InjectionToken, Injector } from '@angular/core';
import { CardDesignComponent } from '../../components/design/slide-up-card/card-design.component';
import { Subscription } from 'rxjs';
import { Direction } from '@angular/cdk/bidi';

export const DATA_INJECTION_TOKEN = new InjectionToken<string>(
  'DATA_INJECTION_TOKEN'
);

@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  private _ref: OverlayRef;
  private _compSub: Subscription;
  private _compRef: ComponentRef<any>;
  private _container;

  constructor(
    private readonly overlay: Overlay,
  ) { }

  public set container(value: any) {
    this._container = value;
  }

  openComponentOverlay<T>(direction: Direction, componentType: ComponentType<T>, data?: any, container?: FlexibleConnectedPositionStrategyOrigin) {
    this._ref = this.overlay.create({
      height: '100%',
      width: '100%',
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(container ?? this._container)
        .withFlexibleDimensions(true)
        .withViewportMargin(0)
        .withPush(false)
        .withPositions([
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'top',
          },
        ]),
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });

    const injector = Injector.create({
      providers: [
        {
          provide: DATA_INJECTION_TOKEN,
          useValue: data
        },
      ],
    });

    this._compRef = this._ref.attach(
      new ComponentPortal(componentType, null, injector)
    );

    this._compSub = (
      this._compRef.instance as CardDesignComponent
    ).onCardClose.subscribe(() => {
      setTimeout(() => {
        this._ref.detach();
        this._compSub.unsubscribe();
      }, 150);
    });
  }
}
